import React, { createContext } from "react";
import { Action, State } from "./type";

const initialState: State = {
  theme: "light",
  pageTheme: undefined,
  userInfo: null,
  isLogin: null,
  locale: "en",
  localeLink: "",
  hideSignUpAndLogIn: false,
  isDemoTrading: false,
  baseUrl: "",
  showTheme: false,
  changeTheme: undefined,
  position: "sticky",
  drawerOpen: false,
  isSticky: false,
  themeLock: false,
  hideAllMenus: false,
  country: "",
  copyTradeUserInfo: undefined,
  userAccountType: undefined,
  appBridge: undefined
};

const StoreContext = createContext<{
  state: State;
  dispatch: React.Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => null
});

export { initialState, StoreContext };
